import { gql } from '@apollo/client'

export const CREATE_MARKETING_URL_TRACKING = gql`
	mutation createMarketingUrlTracking($url: String!) {
		createMarketingUrlTracking(url: $url) {
			success
		}
	}
`
